<template>
  <v-flex xs12>
      <!-- Titulo del dialogo -->
      <v-card>
        <v-card-title>
          <span class="headline">Alta de Prestamo</span>
        </v-card-title>
        <v-card-text class="pb-0">
          <v-container>
            <!-- Formulario Empresa -->
            <v-form ref="form" v-model="valid">
              <v-row>
                <v-col cols="12" sm="6" md="4" class="py-0">
                    <v-select :rules="[v => !!v || 'Campo requerido']" required v-model="altaMovimiento.empresa2" :items="empresas" item-text="text" item-value="item" label="Empresa Origen"></v-select>
                </v-col>
                <v-col cols="12" sm="6" md="4" class="py-0">
                    <v-select :rules="[v => !!v || 'Campo requerido']" required v-model="altaMovimiento.empresa" :items="empresas" item-text="text" item-value="item" label="Empresa Destino"></v-select>
                </v-col> 
                <v-col cols="12" sm="6" md="4" class="py-0">
                    <v-text-field :rules="[v => !!v || 'Campo requerido']" required type="number" prepend-icon="mdi-currency-usd" v-model="altaMovimiento.monto" label="Monto"></v-text-field>
                </v-col>
                <v-col cols="12" sm="6" md="4" class="py-0">
                    <v-menu v-model="menu" :close-on-content-click="false" :nudge-right="40" transition="scale-transition" offset-y min-width="290px" >
                        <template v-slot:activator="{ on }">
                            <v-text-field v-model="altaMovimiento.fecha" label="Fecha" prepend-icon="mdi-calendar-today" readonly v-on="on"></v-text-field>
                        </template>
                        <v-date-picker color="primary" v-model="altaMovimiento.fecha" @input="menu = false"></v-date-picker>
                    </v-menu>
                </v-col>
                <v-col cols="12" sm="6" md="8" class="py-0">
                    <v-textarea v-model="altaMovimiento.nota" label="Nota"></v-textarea>
                </v-col>
              </v-row>
            </v-form>
          </v-container>
        </v-card-text>
        <!-- Cancelar y Guardar -->
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="cerrar()">Cancelar</v-btn>
          <v-btn color="blue darken-1" text :disabled="!valid" @click="saveIngreso">Guardar</v-btn>
        </v-card-actions>
      </v-card>
  </v-flex>
</template>


<!---------- SCRIPTS ---------->

<script>
import axios from "axios"
export default {
    props:{
        datosMovimiento:Object
    },
    data: () => ({
        menu:false,
        empresas:[
            {item:'efi', text:'EFI Industrial'},
            {item:'unoferre', text:'UNO Ferre'},
            {item:'unonegocios', text:'UNO Negocios'}
        ],
        falso:false,
        valid: true,
        altaMovimiento:{
            monto:'',
            empresa2:'',
            empresa:'',
            concepto:1,
            usuario:'',
            nota:'',
            recibido:1,
            fecha:'',
        },
    }), 
    created(){
        this.$store.dispatch('movimiento/getMovimientos')
        this.$store.dispatch('currentUser/getUser')
    },
    computed:{
        currentUser:{
            get(){
                return this.$store.state.currentUser.user
            }
        },
    },
    methods: { 
        cerrar(){
            Object.keys(this.altaMovimiento).forEach(key => {
                return (this.altaMovimiento[key] = "");
            }); 
            this.$emit("cerrarPrestamo", this.falso);
        },
        saveIngreso(){
            this.altaMovimiento.usuario = this.currentUser.id
            axios.post('https://unoweb.uno/api/v1/movimiento/guardar',Object.assign(this.altaMovimiento))
            .then(resp => {
                this.saveGasto()
            })
        },
        saveGasto(){
            this.altaMovimiento.monto = this.altaMovimiento.monto*-1
            this.altaMovimiento.empresa = this.altaMovimiento.empresa2
            axios.post('https://unoweb.uno/api/v1/movimiento/guardar',Object.assign(this.altaMovimiento))
            .then(resp => {
                this.cerrar()
            })
        },
    }, 
}
</script>